export default "__VITE_ASSET__TGhn2pGG__"